import React from 'react';
import { Table } from 'react-bootstrap';

const MostViewedPagesTable = ({ mostViewedPages = [] }) => {
    
    const formattedPages = mostViewedPages.slice(0, 5).map(page => ({
        pageName: page.PageName || page.pageName || 'Unknown Page',
        views: page.TotalViewCount || page.views || 0,
        percentage: page.Percentage || '0'
    }));

    console.log("Formatted pages:", formattedPages);

    const headerStyle = {
        backgroundColor: '#CBA37024',
        color: '#CBA370',
        fontWeight: 'bold',
        padding: '8px 12px',
        fontSize: '13px',
    };

    const viewsStyle = {
        color: '#CBA370',
        fontWeight: '500',
    };

    const cellStyle = {
        padding: '8px 12px',
        fontSize: '13px',
        border: 'none',
    };

    return (
        <div className="col-xxl-8 col-xl-8 col-md-8 p-0 bg-white" style={{ maxWidth: '600px', margin: '24px 14px' }}>
            <div style={{ padding: '10px' }}>
                <h6 className="text-lg mb-3" style={{ 
                    color: '#CBA370', 
                    fontWeight: 'bold',
                    fontSize: '14px'
                }}>
                    Most Viewed Pages
                </h6>

                <div style={{ 
                    border: '1px solid #C8E6C9',
                    borderRadius: '5px',
                    overflow: 'hidden',
                }}>
                    <Table responsive hover className="mb-0" style={{ margin: '0' }}>
                        <thead>
                            <tr>
                                <th style={{ ...headerStyle, width: '50%' }}>Page Name</th>
                                <th style={{ ...headerStyle, width: '10%' }}>Views</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            {formattedPages.length > 0 ? (
                                formattedPages.map((item, index) => (
                                    <tr key={index}>
                                        <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>
                                            <span style={{ 
                                                display: 'inline-block',
                                                maxWidth: '150px',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}>
                                                {item.pageName}
                                            </span>
                                        </td>
                                        <td style={{ ...cellStyle, ...viewsStyle }}>
                                            {item.views}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2" style={{ ...cellStyle, textAlign: 'center' }}>
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
};

export default MostViewedPagesTable;